import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import {
    COOKIE_USER_CULTURE_KEY,
    SEARCH_STRING_LOCALIZATION_KEY,
    getSecondLevelDomain,
    landingSupportedLanguages,
} from '@next/shared';

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        supportedLngs: landingSupportedLanguages,
        fallbackLng: 'en-us',
        load: 'currentOnly',
        debug: true,
        interpolation: {
            escapeValue: false,
        },
        lowerCaseLng: true,
        backend: {
            loadPath: `${process.env.PUBLIC_URL}/localization/{{lng}}.json`,
        },
        detection: {
            order: ['cookie', 'querystring', 'navigator'],
            lookupCookie: COOKIE_USER_CULTURE_KEY,
            lookupQuerystring: SEARCH_STRING_LOCALIZATION_KEY,
            caches: ['cookie'],
            cookieOptions: { domain: getSecondLevelDomain(), secure: true },
        },
    })
    .catch(e => {
        console.error('Failure initialize localization service', e);
    });

export default i18n;
